import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../lib/shadcn/card'
import { Button } from '../../lib/shadcn/button'
import { Eye, Newspaper, Send } from 'lucide-react'
import { toast } from '../../lib/shadcn/sonner'
import { useGetWeeklyDigest, useSendWeeklyDigest } from '../../hooks/backend/dashboardPage'
import { HelpText } from '../../components/HelpText'

interface Digest {
  subject: string
  html: string
}

export default function WeeklyDigestSettings() {
  const getDigest = useGetWeeklyDigest()
  const sendDigest = useSendWeeklyDigest()
  const [shown, setShown] = useState(false)

  const digest = getDigest.data as Digest | null | undefined

  const preview = () => {
    setShown(true)
    void getDigest.trigger({}, { skipCache: true })
  }

  const sendNow = async () => {
    try {
      const res = (await sendDigest.trigger({})) as { recipient?: string } | undefined
      toast.success(`Digest sent to ${res?.recipient ?? 'you'}`)
    } catch (error) {
      toast.error(`Failed to send digest: ${error instanceof Error ? error.message : 'Unknown error'}`)
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Newspaper className="w-4 h-4" />
          Weekly digest
        </CardTitle>
        <CardDescription><HelpText>
          Once a week an email sums up last week&apos;s revenue, bag stock against the reorder
          point, overdue reorder reminders, and this week&apos;s production plan. It goes to your
          Retool email the first time the Hub is opened each week, starting Monday.
        </HelpText></CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" size="sm" onClick={preview} disabled={getDigest.loading} className="gap-1.5">
            <Eye className="w-4 h-4" />
            {getDigest.loading ? 'Building…' : 'Preview'}
          </Button>
          <Button size="sm" onClick={() => void sendNow()} disabled={sendDigest.loading} className="gap-1.5">
            <Send className="w-4 h-4" />
            {sendDigest.loading ? 'Sending…' : 'Email it to me now'}
          </Button>
        </div>

        {getDigest.error && <p className="text-sm text-destructive">{getDigest.error}</p>}

        {shown && digest && (
          <div className="space-y-2">
            <p className="text-sm">
              <span className="text-muted-foreground">Subject: </span>
              {digest.subject}
            </p>
            <iframe
              title="Weekly digest preview"
              srcDoc={digest.html}
              sandbox=""
              className="h-[560px] w-full rounded-md border bg-white"
            />
          </div>
        )}
      </CardContent>
    </Card>
  )
}
